import { useLocation } from 'react-router';

import { OppByTaskTypeChart } from '../../charts/OppByTaskChart';
import { TotalTaskOppChart } from '../../charts/TotalTaskOppChart';
import { useGetFilteredHygieneData } from '../../helpers/data/getHygieneData';
import { useGetFilteredHygieneTasks } from '../../helpers/data/getHygieneTasks';
import {
  getHygieneOpportunity,
  getHygieneOpportunityByTask,
} from '../../helpers/hygieneOpportunity';
import type { THygieneProviderRates } from '../../types';
import { ProviderHeader } from '../ProviderHeader';

import { HygieneProviderTable } from './HygieneProviderTable';

export const ProviderHygiene = ({
  hygieneProviderRates,
}: {
  hygieneProviderRates?: THygieneProviderRates[];
}) => {
  const location = useLocation();
  const id = location.pathname.split('provider/')[1]?.split('/')[0];
  const practiceId =
    location.pathname.split('practice/')[1]?.split('/')[0] === 'undefined'
      ? undefined
      : location.pathname.split('practice/')[1]?.split('/')[0];

  const { filteredData: hygieneData } = useGetFilteredHygieneData();

  const hygieneProvider = hygieneData?.practices
    ?.filter(
      (practice) => !practiceId || practice.practiceVideaId === practiceId,
    )
    ?.flatMap((practice) => {
      return practice?.hygienists?.map((provider) => {
        return {
          ...provider,
          practiceId: practice.practiceId,
          practiceVideaId: practice.practiceVideaId,
          practiceName: practice.practiceName,
        };
      });
    })
    .find(
      (provider) =>
        (provider?.providerVideaId ?? provider?.providerId.toString()) === id,
    );

  const hygieneProviderRate = hygieneProviderRates?.find(
    (provider) => provider?.providerId === id,
  );

  const { data: hygieneProviderData, isLoading: isHygieneLoading } =
    useGetFilteredHygieneTasks({
      providerId: hygieneProvider?.providerId as number,
      practiceId: hygieneProvider?.practiceId,
    });

  const totalHygieneOpportunity = getHygieneOpportunity(hygieneProviderRate);
  const hygieneOpportunityByTx =
    getHygieneOpportunityByTask(hygieneProviderRate);

  return (
    <div className="vai-flex vai-flex-col vai-gap-8 vai-w-full vai-px-8 vai-py-4">
      <ProviderHeader
        singleProvider={{
          providerName: hygieneProvider?.providerName,
          providerVideaId: hygieneProvider?.providerVideaId,
          providerId: hygieneProvider?.providerId,
          practiceName: hygieneProvider?.practiceName,
          practiceId: hygieneProvider?.practiceVideaId,
          providerRole: hygieneProvider?.providerRole,
        }}
      />
      <div className="vai-flex vai-flex-row vai-gap-4">
        <TotalTaskOppChart totalOpp={totalHygieneOpportunity} />
        <OppByTaskTypeChart opportunityByTask={hygieneOpportunityByTx} />
      </div>
      <HygieneProviderTable
        taskDrilldowns={hygieneProviderData}
        isLoading={isHygieneLoading}
      />
    </div>
  );
};
